import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const StatusContainer = styled(motion.div)`
	color: ${(props) => props.color};
	background-color: ${(props) => props.background};
	border: none;
	padding: 5px 15px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	margin: 4px 2px;
	cursor: pointer;
	border-radius: 16px;
`;
